var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "white",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58c.18-.14.23-.39.12-.59l-1.92-3.32c-.11-.19-.35-.26-.55-.2l-2.39.96c-.5-.38-1.02-.73-1.58-1.02l-.36-2.54c-.03-.21-.21-.36-.42-.36h-3.84c-.21 0-.39.15-.42.36l-.36 2.54c-.56.29-1.08.64-1.58 1.02l-2.39-.96c-.2-.08-.44.01-.55.2l-1.92 3.32c-.11.19-.06.45.12.59l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58c-.18.14-.23.39-.12.59l1.92 3.32c.11.19.35.26.55.2l2.39-.96c.5.38 1.02.73 1.58 1.02l.36 2.54c.03.21.21.36.42.36h3.84c.21 0 .39-.15.42-.36l.36-2.54c.56-.29 1.08-.64 1.58-1.02l2.39.96c.2.08.44-.01.55-.2l1.92-3.32c.11-.19.06-.45-.12-.59l-2.03-1.58zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.a2a4fd3ff827c4bb49d3d25f54e5d72f.svg";
export { ForwardRef as ReactComponent };